module.exports = __webpack_public_path__ + "img/sparkles-bg-mob.6fef6cf.svg";